var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 37,
    fill: "#F6F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3164 46.0684H38.1626",
    stroke: "#43474B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2383 54.6085L28.2001 48.916",
    stroke: "#43474B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2383 40.375L29.6232 43.2212",
    stroke: "#43474B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1038 23.3837L53.4449 19.0859C53.6711 19.0147 53.9123 19.0062 54.1429 19.0613C54.3735 19.1164 54.5848 19.2332 54.7542 19.399C54.9331 19.5559 55.0688 19.756 55.1485 19.9802C55.2282 20.2043 55.2493 20.4452 55.2096 20.6798L52.0788 36.6471C51.908 36.2202 51.7372 35.7648 51.5949 35.3094C50.6883 32.0036 48.7665 29.0659 46.1008 26.9109C43.4351 24.7558 40.16 23.4922 36.7376 23.2983C33.3152 23.4922 30.0401 24.7558 27.3744 26.9109C24.7087 29.0659 22.7869 32.0036 21.8803 35.3094C21.738 35.7932 21.5672 36.2202 21.3964 36.6756L18.2656 20.6798C18.2259 20.4452 18.247 20.2043 18.3267 19.9802C18.4064 19.756 18.5421 19.5559 18.721 19.399C18.8904 19.2332 19.1017 19.1164 19.3323 19.0613C19.5629 19.0062 19.8041 19.0147 20.0303 19.0859L35.3714 23.3837",
    stroke: "#43474B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0113 54.123C38.2017 54.7685 35.2823 54.7685 32.4727 54.123",
    stroke: "#43474B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2391 54.6085L45.2773 48.916",
    stroke: "#43474B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2365 40.375L43.8516 43.2212",
    stroke: "#43474B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatAvatar);
export default __webpack_public_path__ + "static/media/cat-avatar.febe2659a48d839db591aaa357829f98.svg";
export { ForwardRef as ReactComponent };